import { useGetForeignCurrencyHistory } from '@/hooks/useGetForeignCurrencyHistory';
import React from 'react';
import styled from 'styled-components';

function FXReceiptSummary() {
  const { summary } = useGetForeignCurrencyHistory();

  if (!summary) return null;

  return (
    <SummaryContainer>
      <SummaryCard>
        <Label>전체 {summary.totalCount ?? 0}건</Label>
        <Amount>
          {summary.totalSum.toLocaleString()} <Unit>원</Unit>
        </Amount>
      </SummaryCard>
      <SummaryCard>
        <Label>완료 {summary.receivedCount ?? 0}건</Label>
        <Amount>
          {summary.receivedSum.toLocaleString()} <Unit>원</Unit>
        </Amount>
      </SummaryCard>
      <SummaryCard>
        <Label>취소 {summary.canceledCount ?? 0}건</Label>
        <Amount>
          {summary.canceledSum.toLocaleString()} <Unit>원</Unit>
        </Amount>
      </SummaryCard>
    </SummaryContainer>
  );
}

export default FXReceiptSummary;

const SummaryContainer = styled.div`
  display: flex;
  gap: 2px;
  padding: 8px;
  margin-bottom: 14px;
  background: var(--Mono-00, #fff);
  border-radius: 12px;
`;

const SummaryCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px 12px 18px;
  background: var(--Mono-05, #f5f6f7);

  &:first-child {
    border-radius: 12px 0 0 12px;
  }

  &:last-child {
    border-radius: 0 12px 12px 0;
  }
`;

const Label = styled.div`
  color: var(--Mono-65, #5f6165);
  /* WebTitle/14_SB */
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const Amount = styled.div`
  color: var(--Mono-80, #3a3b3e);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 30px */
  letter-spacing: -0.4px;
`;

const Unit = styled.span`
  color: var(--Mono-35, #a7a7a7);
`;
